import React from "react";
import ReactDOM from "react-dom";
import { AppBar, Box, Button, CssBaseline, IconButton, Menu, MenuItem, Tooltip, Typography, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { Brightness4, Brightness7, Person } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Logo } from "frontend/src/ui/logo";
import { Player } from "frontend/src/features/show-player";
import { useViewer } from "frontend/src/domain/session";
import { logout } from "frontend/src/features/session";
import { useThemeMode } from "frontend/src/shared/theme-mode";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        position: "relative",
        minHeight: "100vh",
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        backgroundColor: theme.palette.type === "dark" ? "#101418" : "#eef3f5",
        overflow: "hidden",
        "&:before": {
            content: '""',
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundImage: theme.palette.type === "dark"
                ? "url('/images/client-dashboard-bg.jpg')"
                : "url('/images/client-dashboard-bg-light.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: theme.palette.type === "dark" ? 0.72 : 0.94,
            transform: "scale(1.03)",
            pointerEvents: "none",
        },
        "&:after": {
            content: '""',
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: theme.palette.type === "dark"
                ? "rgba(5, 9, 14, 0.24)"
                : "rgba(14, 27, 42, 0.12)",
            pointerEvents: "none",
        },
    },
    appBar: {
        position: "relative",
        zIndex: 2,
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        backgroundColor: theme.palette.type === "dark"
            ? "rgba(15, 21, 31, 0.30)"
            : "rgba(255, 255, 255, 0.28)",
        backdropFilter: "blur(22px) saturate(145%)",
        WebkitBackdropFilter: "blur(22px) saturate(145%)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.16)",
        boxShadow: "0 16px 40px rgba(0, 0, 0, 0.12)",
    },
    box: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 64,
    },
    button: {
        color: "inherit",
        textTransform: "initial",
    },
    content: {
        position: "relative",
        zIndex: 1,
        paddingBottom: 140,
    },
    themeButton: {
        color: "inherit",
        marginRight: theme.spacing(1),
    },
}); });
var UserMenu = function () {
    var _a;
    var classes = useStyles();
    var user = useViewer().user;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var onLogoutClick = function () {
        logout();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: classes.button, onClick: handleClick },
            React.createElement(Person, null),
            React.createElement(Box, { ml: 1 },
                React.createElement(Typography, null, (_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : React.createElement(Skeleton, { width: 100 })))),
        React.createElement(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "right",
            }, keepMounted: true, onClose: handleClose, getContentAnchorEl: null },
            React.createElement(MenuItem, { onClick: onLogoutClick }, "\u0412\u044B\u0445\u043E\u0434"))));
};
export var EmployeeUserLayout = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    var _b = useThemeMode(), mode = _b.mode, toggleMode = _b.toggleMode;
    return (React.createElement(Box, { className: classes.root },
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "static", elevation: 0, className: classes.appBar },
            React.createElement(Box, { pl: 3, pr: 3, className: classes.box },
                React.createElement(Logo, { width: 250 }),
                React.createElement(Box, { ml: "auto", display: "flex" },
                    React.createElement(Tooltip, { title: mode === "dark"
                            ? "Включить светлый режим"
                            : "Включить темный режим" },
                        React.createElement(IconButton, { className: classes.themeButton, onClick: toggleMode }, mode === "dark" ? React.createElement(Brightness7, null) : React.createElement(Brightness4, null))),
                    React.createElement(UserMenu, null)))),
        React.createElement(Box, { mt: 3, display: "flex", justifyContent: "center", className: classes.content },
            React.createElement(Box, { width: "90%", maxWidth: 1200 }, children)),
        ReactDOM.createPortal(React.createElement(Player, { fullWidth: true }), document.body)));
};
